import { render, staticRenderFns } from "./stepHeader.vue?vue&type=template&id=3a9d283e&scoped=true&"
import script from "./stepHeader.vue?vue&type=script&lang=js&"
export * from "./stepHeader.vue?vue&type=script&lang=js&"
import style0 from "./stepHeader.vue?vue&type=style&index=0&id=3a9d283e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9d283e",
  null
  
)

export default component.exports